import React, { useState } from "react";
import ScenarioFooter from "../../../../components/ScenarioFooter";

import "./Scenario1.scss";
import BaseModal from "../../../../modals/BaseModal";

const Scenario1 = ({ src }) => {
  const [isOpen, setIsOpen] = useState(true);
  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <section className="Scenario1">
      <div className="Scenario1-cont">
        <h1>SCENARIO 1</h1>
        <div>
          <video controls>
            <source src={src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
      <BaseModal isOpen={isOpen} className="modal-md" onClose={handleClose}>
        <div className="Assessment_Start">
          <h2>Let’s set you up for success 👌</h2>
          <ul>
            <li>
              Make sure you have 15–20 quiet minutes <br></br>(no rush, but fewer
              distractions help)
            </li>
            <li>Complete 4 scenarios — go with your first instinct</li>
            <li>
              When the Levitating Robot pops up 🤖, your recommendations are
              being created
            </li>
            <li>Let’s begin</li>
          </ul>
          <div className="d-flex justify-center Assessment_Start_Button">
            <button
              className="BookModal__Content__btnCont__BookBtn"
              onClick={handleClose}
            >
              <p className="BookModal__Content__btnCont__BookBtn__text">Okay</p>
            </button>
          </div>
        </div>
      </BaseModal>
      <ScenarioFooter variation="scenario" where="1" />
    </section>
  );
};

export default Scenario1;
